module.exports = __webpack_public_path__ + "static/media/horse_dice.4fb95343.png";